import euscpScriptUrl from "./euscp/euscp.js?url"

declare global {
  interface Window {
    EndUser: typeof import("./euscp/euscp").EndUser
    EndUserConstants: typeof import("./euscp/euscp").EndUserConstants
  }
}

let scriptPromise: Promise<void> | null = null

// euscp.js is a webpack UMD bundle built with the default `this` global
// object (rather than `window`), so it must run as a classic script — as an
// ES module import its top-level `this` would be `undefined` in strict mode
// and the bundle would throw while assigning its exports onto it. Shared by
// both the hardware (SW) and dev-only file-key (JS) loaders so the script
// tag is only ever injected once.
export function loadEuscpScript(): Promise<void> {
  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement("script")
      script.src = euscpScriptUrl
      script.onload = () => resolve()
      script.onerror = () =>
        reject(new Error("Не вдалося завантажити бібліотеку КЕП"))
      document.head.appendChild(script)
    })
  }
  return scriptPromise
}
